/*
    Defines what is required in the project parent controller:
    @name allReviews
    @description Defines the page for submitting a new review
    @requires $scope.details
    @requires $scope.isProfessional
    @requires $scope.goToDisclaimer
 */
module.exports = function (bootstrap) {
    bootstrap.directive('allReviews', function () {
        return {
            restrict: 'A',
            scope: false,
            replace: false,
            perObject:"=?",
            coreMetricsConfig: "=",
            template: require('directives/reviews/allReviews.html'),
            controller: ['$scope', '$state', 'session', 'modal', function ($scope) {

                $scope.limit = $scope.perObject.reviews.length;

            }]
        };
    });
};